import { useEffect, useRef } from "react";




export function Terms() {
    const focusRef = useRef(null);

    useEffect(() => {
        focusRef.current?.focus();
    }, []);


    return (
        <div className="bg-gray-100 text-gray-900 min-h-screen">
            <div ref={focusRef} tabIndex={0} className="sr-only">Start of [Page Name] Page</div>
            {/* Header Section */}
            <header className="rounded bg-indigo-800 py-6">
                <div className="container mx-auto px-4 text-center">
                    <h1 className="text-4xl font-bold text-white">Terms of Use</h1>
                    <p className="mt-2 text-lg text-indigo-50">SendFalcon Self-Hosted Email Service</p>
                </div>
            </header>

            {/* Main Content */}
            <main className="container mx-auto px-4 py-12">
                {/* Introduction Section */}
                <section className="mb-12">
                    <h2 className="text-3xl font-semibold text-indigo-400 mb-4">Introduction</h2>
                    <p className="text-gray-700 leading-relaxed">
                        Welcome to the Terms of Use for SendFalcon, a self-hosted email service designed for businesses to manage secure and private communications. By using SendFalcon, you agree to comply with these terms, which govern the use of our software and services. These terms apply to all users who install, configure, or operate SendFalcon on their infrastructure.
                    </p>
                </section>

                {/* Usage Guidelines Section */}
                <section className="mb-12">
                    <h2 className="text-3xl font-semibold text-indigo-400 mb-4">Usage Guidelines</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="bg-indigo-800 p-6 rounded-lg shadow-lg">
                            <h3 className="text-xl font-bold text-white mb-2">Permitted Use</h3>
                            <p className="text-indigo-100">
                                SendFalcon may be used for lawful business communications, including internal and external email exchanges. You are responsible for ensuring compliance with all applicable laws and regulations when using the service.
                            </p>
                        </div>
                        <div className="bg-indigo-800 p-6 rounded-lg shadow-lg">
                            <h3 className="text-xl font-bold text-white mb-2">Prohibited Activities</h3>
                            <p className="text-indigo-100">
                                You may not use SendFalcon for illegal activities, including but not limited to sending spam, phishing emails, or any content that violates intellectual property rights or privacy laws.
                            </p>
                        </div>
                    </div>
                </section>

                {/* Responsibilities Section */}
                <section className="mb-12">
                    <h2 className="text-3xl font-semibold text-indigo-400 mb-4">Your Responsibilities</h2>
                    <p className="text-gray-700 leading-relaxed">
                        As a self-hosted service, you are responsible for the installation, maintenance, and security of your SendFalcon instance. This includes ensuring proper server configuration, applying updates, and safeguarding user data in accordance with applicable data protection regulations.
                    </p>
                    <ul className="list-disc list-inside text-gray-700 mt-4">
                        <li>Maintain the security of your server infrastructure.</li>
                        <li>Regularly update SendFalcon software to the latest version.</li>
                        <li>Ensure compliance with local and international privacy laws.</li>
                    </ul>
                </section>

                {/* Limitation of Liability Section */}
                <section className="mb-12">
                    <h2 className="text-3xl font-semibold text-indigo-400 mb-4">Limitation of Liability</h2>
                    <p className="text-gray-700 leading-relaxed">
                        SendFalcon is provided "as is" without warranties of any kind. We are not liable for any damages arising from the use or inability to use the service, including data loss or service interruptions, to the extent permitted by law.
                    </p>
                </section>

                {/* Changes to Terms Section */}
                <section className="mb-12">
                    <h2 className="text-3xl font-semibold text-indigo-400 mb-4">Changes to Terms</h2>
                    <p className="text-gray-700 leading-relaxed">
                        We may update these Terms of Use from time to time. Any changes will be posted on this page, and it is your responsibility to review them periodically. Continued use of SendFalcon after changes constitutes acceptance of the updated terms.
                    </p>
                </section>
            </main>
        </div>
    );
};